"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _antd = require("antd");

var PastProblems = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PastProblems, _Component);

  var _super = (0, _createSuper2.default)(PastProblems);

  function PastProblems() {
    var _this;

    (0, _classCallCheck2.default)(this, PastProblems);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      pastproblems: []
    };
    return _this;
  }

  (0, _createClass2.default)(PastProblems, [{
    key: "fetchPastproblem",
    value: function () {
      var _fetchPastproblem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        var url;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _config.default.getproblemform;

                _axios.default.get(url).then(function (resp) {
                  console.log(resp);

                  _this2.setState({
                    pastproblems: resp.data
                  });
                }, function (error) {
                  console.log(error);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchPastproblem() {
        return _fetchPastproblem.apply(this, arguments);
      }

      return fetchPastproblem;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchPastproblem();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps !== this.props) this.fetchPastproblem();
    }
  }, {
    key: "render",
    value: function render() {
      var pastproblems = this.state.pastproblems;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement(_antd.Card, null, pastproblems.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
        span: 22,
        offset: 1
      }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
        style: {
          backgroundColor: "skyblue",
          margin: 1,
          borderRadius: "8px",
          color: "black"
        },
        className: "border"
      }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
        span: 1,
        className: "m-2 text-center"
      }, "S.NO."), /*#__PURE__*/_react.default.createElement(_antd.Col, {
        span: 3,
        className: "m-2 text-center"
      }, "Date"), /*#__PURE__*/_react.default.createElement(_antd.Col, {
        span: 6,
        className: "m-2 text-center"
      }, "Problem"), /*#__PURE__*/_react.default.createElement(_antd.Col, {
        span: 4,
        className: "m-2 text-center"
      }, "Status"), /*#__PURE__*/_react.default.createElement(_antd.Col, {
        span: 2,
        className: "m-2 text-center"
      }, "Details"), /*#__PURE__*/_react.default.createElement(_antd.Col, {
        span: 2,
        className: "m-2 text-center"
      }, "CommentbyTech")))), pastproblems.map(function (st, index) {
        return /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
          span: 22,
          offset: 1
        }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
          style: {
            backgroundColor: "white",
            margin: 1,
            borderRadius: "8px",
            color: "black"
          },
          className: "border"
        }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
          span: 1,
          className: "m-2 text-center"
        }, index + 1), /*#__PURE__*/_react.default.createElement(_antd.Col, {
          span: 3,
          className: "m-2 text-center"
        }, st.date.substring(0, 10)), /*#__PURE__*/_react.default.createElement(_antd.Col, {
          span: 6,
          className: "m-2 text-center"
        }, st.problems), /*#__PURE__*/_react.default.createElement(_antd.Col, {
          span: 4,
          className: "m-2 text-center"
        }, st.status), /*#__PURE__*/_react.default.createElement(_antd.Col, {
          span: 2,
          className: "m-2 text-center"
        }, st.Details), /*#__PURE__*/_react.default.createElement(_antd.Col, {
          span: 2,
          className: "m-2 text-center"
        }, st.CommentbyTech))));
      })) : /*#__PURE__*/_react.default.createElement("h1", null, "No problems")));
    }
  }]);
  return PastProblems;
}(_react.Component);

var _default = PastProblems;
exports.default = _default;